module.exports = __webpack_public_path__ + "img/Tablet - 65.d0a41443.png";